import {Numbers} from "@/utils/Numbers";

export const FinalReportInvoicesExporter = {

	generate (invoicesComponent) {
		return {
			invoicesAdministrativeCosts: this.getAdministrativeCosts(invoicesComponent),
			invoicesAdministrativeSummary: this.getAdministrativeSummary(invoicesComponent),
			invoicesActionCosts: this.getActionCosts(invoicesComponent),
			invoicesActionSummary: this.getActionSummary(invoicesComponent),
			invoicesWholeSummary: this.getWholeSummary(invoicesComponent)
		};
	},

	getAdministrativeCosts (invoicesComponent) {
		let costs = [];
		let administrativeCostsInvoices = invoicesComponent.administrativeCostsInvoices;
		for (let serial of Object.keys(administrativeCostsInvoices)) {
			let invoiceIdx = 0;
			let invoicesBySerialNumber = [];
			for (let invoice of administrativeCostsInvoices[serial]) {
				let item = {};
				item.ordinalNumber = (1 + this.getAdministrativeCostInvoiceIndex(invoicesComponent, serial, invoiceIdx)).toString();
				item.serialNumber = invoice.administrative[0] ? invoice.administrative[0].serialNumber.toString().split('.')[0] : null;
				item.documentName = invoice.documentName;
				item.documentNumber = invoice.documentNumber;
				item.totalValue = invoice.totalValue;
				item.documentDate = invoice.documentDate;
				item.paymentDate = invoice.paymentDates[0];
				item.costs = this.getSingleAdministrativeCostList(invoicesComponent, invoice.administrative, serial, invoiceIdx);
				invoicesBySerialNumber.push(item);
				invoiceIdx++;
			}
			costs.push(invoicesBySerialNumber);
		}
		return costs;
	},

	getSingleAdministrativeCostList (invoicesComponent, administrativeCosts, serial, invoiceIdx) {
		let costs = [];
		let index = 0;
		for (let cost of administrativeCosts) {
			let costRef = invoicesComponent.$refs['invoicesSingleAdministrativeCost-' + serial + '-' + invoiceIdx + '-' + index][0];
			let item = {};
			item.serialNumber = costRef.lp;
			item.description = cost.description;
			item.donation = Numbers.methods.formatMoney(costRef.costOfType(['z dotacji']));
			item.other = Numbers.methods.formatMoney(costRef.costOfType([
				'środki finansowe własne',
				'świadczenie pieniężne od odbiorców',
				'środki finansowe z innych źródeł publicznych',
				'pozostałe']));
			item.interests = Numbers.methods.formatMoney(costRef.costOfType(['odsetki', 'przychody']));
			item.ownInKind = Numbers.methods.formatMoney(costRef.costOfType(['wkład rzeczowy']));
			item.ownHuman = Numbers.methods.formatMoney(costRef.costOfType(['wkład osobowy']));
			costs.push(item);
			index++;
		}
		return costs;
	},

	getAdministrativeSummary (ref) {
		return {
			donation: Numbers.methods.formatMoney(ref.costOfTypeAdministrativeCostsInvoices(['z dotacji'])),
			other: Numbers.methods.formatMoney(ref.costOfTypeAdministrativeCostsInvoices([
				'środki finansowe własne',
				'świadczenie pieniężne od odbiorców',
				'środki finansowe z innych źródeł publicznych',
				'pozostałe'])),
			interests: Numbers.methods.formatMoney(ref.costOfTypeAdministrativeCostsInvoices(['odsetki', 'przychody'])),
			ownInKind: Numbers.methods.formatMoney(ref.costOfTypeAdministrativeCostsInvoices(['wkład rzeczowy'])),
			ownHuman: Numbers.methods.formatMoney(ref.costOfTypeAdministrativeCostsInvoices(['wkład osobowy']))
		};
	},

	getActionCosts (invoicesComponent) {
		let costs = [];
		let actionsCostsInvoices = invoicesComponent.actionsCostsInvoices;
		for (let serialAction of Object.keys(actionsCostsInvoices)) {
			let invoicesByActions = [];
			let costSerialNumbers = Object.keys(actionsCostsInvoices[serialAction]);
			for (let serialCost of costSerialNumbers) {
				let invoicesBySerialNumber = [];
				let invoiceIdx = 0;
				for (let invoice of actionsCostsInvoices[serialAction][serialCost]) {
					let item = {};
					item.ordinalNumber = (1 + this.getActionCostInvoiceIndex(invoicesComponent, serialAction, serialCost, invoiceIdx)).toString();
					item.serialNumber = invoice.actions[0] ? invoice.actions[0].serialNumber : null;
					item.documentName = invoice.documentName;
					item.documentNumber = invoice.documentNumber;
					item.totalValue = invoice.totalValue;
					item.documentDate = invoice.documentDate;
					item.paymentDate = invoice.paymentDates[0];
					item.costs = this.getSingleActionCostList(invoicesComponent, invoice.actions, serialAction, serialCost, invoiceIdx);
					invoicesBySerialNumber.push(item);
					invoiceIdx++;
				}
				invoicesByActions.push(invoicesBySerialNumber);
			}
			costs.push(invoicesByActions);
		}
		return costs;
	},

	getSingleActionCostList (invoicesComponent, actionCosts, serialAction, serialCost, invoiceIdx) {
		let costs = [];
		let actionIdx = 0;
		for (let action of actionCosts) {
			let costIdx = 0;
			for (let cost of action.costs) {
				let costRef = invoicesComponent.$refs['invoicesSingleActionCost-' + serialAction + '-' + serialCost + '-' + invoiceIdx + '-' + actionIdx + '-' + costIdx][0];
				let item = {};
				item.serialNumber = costRef.lp;
				item.description = cost.description;
				item.donation = Numbers.methods.formatMoney(costRef.costOfType(['z dotacji']));
				item.other = Numbers.methods.formatMoney(costRef.costOfType([
					'środki finansowe własne',
					'świadczenie pieniężne od odbiorców',
					'środki finansowe z innych źródeł publicznych',
					'pozostałe']));
				item.interests = Numbers.methods.formatMoney(costRef.costOfType(['odsetki', 'przychody']));
				item.ownInKind = Numbers.methods.formatMoney(costRef.costOfType(['wkład rzeczowy']));
				item.ownHuman = Numbers.methods.formatMoney(costRef.costOfType(['wkład osobowy']));
				costs.push(item);
				costIdx++;
			}
			actionIdx++;
		}
		return costs;
	},

	getActionSummary (ref) {
		return {
			donation: Numbers.methods.formatMoney(ref.costOfTypeActionsCostsInvoices(['z dotacji'])),
			other: Numbers.methods.formatMoney(ref.costOfTypeActionsCostsInvoices([
				'środki finansowe własne',
				'świadczenie pieniężne od odbiorców',
				'środki finansowe z innych źródeł publicznych',
				'pozostałe'])),
			interests: Numbers.methods.formatMoney(ref.costOfTypeActionsCostsInvoices(['odsetki', 'przychody'])),
			ownInKind: Numbers.methods.formatMoney(ref.costOfTypeActionsCostsInvoices(['wkład rzeczowy'])),
			ownHuman: Numbers.methods.formatMoney(ref.costOfTypeActionsCostsInvoices(['wkład osobowy']))
		};
	},

	getWholeSummary (ref) {
		return {
			donation: Numbers.methods.formatMoney(ref.costOfTypeAllCostsInvoices(['z dotacji'])),
			other: Numbers.methods.formatMoney(ref.costOfTypeAllCostsInvoices([
				'środki finansowe własne',
				'świadczenie pieniężne od odbiorców',
				'środki finansowe z innych źródeł publicznych',
				'pozostałe'])),
			interests: Numbers.methods.formatMoney(ref.costOfTypeAllCostsInvoices(['odsetki', 'przychody'])),
			ownInKind: Numbers.methods.formatMoney(ref.costOfTypeAllCostsInvoices(['wkład rzeczowy'])),
			ownHuman: Numbers.methods.formatMoney(ref.costOfTypeAllCostsInvoices(['wkład osobowy']))
		};
	},

	getAdministrativeCostInvoiceIndex (invoicesComponent, serial, invoiceIdx) {
		let before = 0;
		let keys = Object.keys(invoicesComponent.administrativeCostsInvoices);
		for (let i = 0; i < keys.length; i++) {
			if (parseInt(keys[i]) < serial && invoicesComponent.administrativeCostsInvoices[keys[i]]) {
				before += invoicesComponent.administrativeCostsInvoices[keys[i]].length;
			}
		}
		return invoiceIdx + before;
	},

	getActionCostInvoiceIndex (invoicesComponent, serialAction, serialCost, invoiceIdx) {
		let before = 0;
		let actionKeys = Object.keys(invoicesComponent.actionsCostsInvoices);
		for (let i = 0; i < actionKeys.length; i++) {
			if (parseInt(actionKeys[i]) <= serialAction) {
				let costKeys = Object.keys(invoicesComponent.actionsCostsInvoices[actionKeys[i]]);
				for (let j = 0; j < costKeys.length; j++) {
					if (parseInt(actionKeys[i]) < serialAction || parseInt(costKeys[j]) < serialCost) {
						before += invoicesComponent.actionsCostsInvoices[actionKeys[i]][costKeys[j]].length;
					}
				}
			}
		}
		return invoiceIdx + before;
	},
};